import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { BASE_PATH } from '@api';
import { LhI18nService } from '@ewafi/angular/i18n';
import { provideEwafi } from '@ewafi/angular/init';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { bffInterceptor } from './interceptors/bff.interceptor';
import { authCheckInitializer } from './initializers/auth-check.initializer';
import { from, switchMap } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptors([bffInterceptor])),
    provideEwafi(),
    {
      provide: BASE_PATH,
      useValue: `${environment.bffConfig.url}${environment.bffConfig.api}`,
    },
    provideAppInitializer(authCheckInitializer),
    provideAppInitializer(() => {
      const i18nService = inject(LhI18nService);
      const urlParams = new URLSearchParams(window.location.search);
      const locale = urlParams.get('locale');
      if (locale) {
        i18nService.setCurrentLanguage({ locale, localeName: locale, englishName: locale });
      }

      // if the users wants to change the language in expolorer, 
      // remove display:none style for lh-languagePicker in app.component.scss
       i18nService.getCurrentLanguage().pipe(
        switchMap(currentLanguage =>
          from(fetch(`assets/i18n/${currentLanguage.locale}.json`).then(res => res.json()))
        ),
      ).subscribe((response: Record<string, Record<string, string>>) =>
        i18nService.setLabels(
          new Map<string, string>(Object.entries(response['i18n'] ?? {}))
        )
      ); 
    }),
  ],
};
